/**
 * EventPady+ App Root
 *
 * Wires together the three global providers:
 *   1. QueryClientProvider — TanStack Query cache (queryClient.ts)
 *   2. AuthProvider       — JWT session management (AuthContext.tsx)
 *   3. RouterProvider     — React Router v7 (routes/index.tsx)
 *   4. Toaster            — Sonner toast notifications (app-level)
 */
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { router } from '@/routes'
import { queryClient } from '@/services/api/queryClient'
import { Toaster } from '@/components/ui/sonner'

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        {/* Sonner toast container — position top-right, rich colour variants */}
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  )
}
